import { Card, Form, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from '../../../utils/zustand/hooks/useAppTheme';
import { useProfile } from '../../../utils/zustand/hooks/useProfile';
const { Title, Text } = Typography;

const ProfileComponent = () => {
  const { profile, setProfile, clearProfile } = useProfile();
  const { _theme, setTheme } = useAppTheme();
  const [form] = Form.useForm();
  const [_isEditing, setIsEditing] = useState(false);
  const { t } = useTranslation(['dashboard', 'common']);

  const _onChangeTheme = (value) => {
    setTheme(value);
  };

  const _onFinish = (values) => {
    console.log('Updating profile (Zustand):', values);
    setProfile({
      name: values.name,
      email: values.email,
      id: profile?.id || Date.now(), // Génère un ID si pas présent
    });
    setIsEditing(false);
  };

  const _handleEdit = () => {
    setIsEditing(true);
    form.setFieldsValue({
      name: profile?.name || '',
      email: profile?.email || '',
    });
  };

  const _handleCancel = () => {
    setIsEditing(false);
    form.resetFields();
  };

  const _handleClearProfile = () => {
    console.log('Clearing profile (Zustand)');
    clearProfile();
  };

  const _handleSetSampleProfile = () => {
    const sampleProfile = {
      id: Date.now(),
      name: 'John Doe',
      email: 'john.doe@example.com',
    };
    console.log('Setting sample profile (Zustand):', sampleProfile);
    setProfile(sampleProfile);
  };

  return (
    <Card title={t('dashboard:profile.title')}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <div>
            <Title level={4} style={{ margin: 0 }}>
              {profile?.name || t('dashboard:profile.no_name')}
            </Title>
            <Text>{profile?.email || t('dashboard:profile.no_email')}</Text>
            {!profile && (
              <div style={{ marginTop: 8 }}>
                <Text type="secondary">
                  {t('dashboard:profile.no_profile')}
                </Text>
              </div>
            )}
          </div>
        </div>
        {/* Section Thème */}
        {/* TODO: handle theme with cookies and/or profile settings */}
        {/* <Flex gap="small" align="flex-start" vertical>
          <Title level={4}>{t('dashboard:profile.theme_settings')}</Title>
          <Segmented
            value={theme?.name}
            onChange={onChangeTheme}
            options={[
              {
                label: (
                  <div style={{ padding: 4 }}>
                    <Avatar icon={<SunOutlined />} />
                    <div>{t('dashboard:profile.light_theme')}</div>
                  </div>
                ),
                value: 'light',
              },
              {
                label: (
                  <div style={{ padding: 4 }}>
                    <Avatar
                      style={{ backgroundColor: '#000' }}
                      icon={<MoonOutlined />}
                    />
                    <div>{t('dashboard:profile.dark_theme')}</div>
                  </div>
                ),
                value: 'dark',
              },
            ]}
          />
        </Flex> */}
      </Space>
    </Card>
  );
};

export default ProfileComponent;
